import React, { useState } from 'react';
import api, { getVideoStreamUrl } from '../../services/api';
import './TutorialButton.css'; // You might need to create this CSS file

const TutorialButton = ({ videoPath, buttonText = "Ver Tutorial", buttonStyle = {} }) => {
    const [showModal, setShowModal] = useState(false);
    const [video, setVideo] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleOpen = async () => {
        setShowModal(true);
        if (!video) {
            setLoading(true);
            setError(null);
            try {
                const response = await api.get(`/video/find?path=${encodeURIComponent(videoPath)}`);
                if (response.data.success && response.data.data) {
                    setVideo(response.data.data);
                } else {
                    setError("Vídeo não encontrado.");
                }
            } catch (err) {
                console.error("Erro ao buscar vídeo:", err);
                setError("Erro ao carregar o vídeo. Tente novamente mais tarde.");
            } finally {
                setLoading(false);
            }
        }
    };

    const handleClose = () => {
        setShowModal(false);
        // Optional: Reset video state if you want to re-fetch every time, but caching is better
    };

    return (
        <>
            <button
                className="btn-tutorial"
                onClick={handleOpen}
                style={{
                    backgroundColor: '#007bff', // Blue (Bootstrap primary) instead of Red
                    color: 'white',
                    border: 'none',
                    padding: '5px 10px',
                    borderRadius: '5px',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '5px',
                    ...buttonStyle
                }}
            >
                <i className="fas fa-play-circle"></i> {buttonText}
            </button>

            {showModal && (
                <div className="tutorial-modal-overlay" onClick={handleClose}>
                    <div className="tutorial-modal-content" onClick={e => e.stopPropagation()}>
                        <div className="tutorial-modal-header">
                            <h3>{video ? (video.descricao || "Tutorial") : "Carregando..."}</h3>
                            <button className="close-btn" onClick={handleClose}>&times;</button>
                        </div>
                        <div className="tutorial-modal-body">
                            {loading && <div className="loading-spinner">Carregando vídeo...</div>}
                            {error && <div className="error-message">{error}</div>}

                            {video && (
                                <video
                                    controls
                                    autoPlay
                                    className="tutorial-video"
                                    src={getVideoStreamUrl(video.id_video)}
                                    style={{ width: '100%', maxHeight: '70vh' }}
                                >
                                    Seu navegador não suporta vídeos.
                                </video>
                            )}
                        </div>
                    </div>
                </div>
            )}

        </>
    );
};

export default TutorialButton;
